import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const OpeationCategory = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  // alert messages on operations
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  const [errors, setErrors] = useState({
    OpCategoryDescription: false,
    StitchLengthMin: false,
    StitchLengthMax: false,
    PerformancePercentage: false,
    Active: false,
  });
  const [helperTexts, setHelperTexts] = useState({
    OpCategoryDescription: '',
    StitchLengthMin: '',
    StitchLengthMax: '',
    PerformancePercentage: '',
    Active: '',
  });

  // input fields state values

  const [OpCategoryDescription, setOpCategoryDescription] = useState('');
  const [StitchLengthMin, setStitchLengthMin] = useState('');
  const [StitchLengthMax, setStitchLengthMax] = useState('');
  const [PerformancePercentage, setPerformancePercentage] = useState('');
  const [Active, setActive] = useState("Y");

  const [opCatData, setopCatData] = useState([]);

  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();
  const [openLoader, setOpenLoader] = useState(false);

  // API Integration
  useEffect(() => {
    GetAllOperationCategoryGroupMst();
  }, []);

  // get all Users Request
  const GetAllOperationCategoryGroupMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperationCategoryGroupMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setopCatData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // post Request to Add new record
  const InsertOperationCategoryGrpMstData = async (newUser) => {
    try {
      const res = await axios.instance.post('/InsertOperationCategoryGrpMstData', newUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetAllOperationCategoryGroupMst();
      setAlertType('success');
      setAlertMessage(operation === 'Edit' ? 'New Category Updated Successfully!' : 'New Category Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding Category:', error);
      setAlertType('error');
      setAlertMessage('Failed to proceed!');
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const DeleteOperationCategoryMst = async (ids) => {
    try {
      await axios.instance
        .delete(`/DeleteOperationCategoryMst/${ids}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetAllOperationCategoryGroupMst();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Category Deleted Successfully!');
            setopenAlert(true);
          } else {
            GetAllOperationCategoryGroupMst();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting User:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the User.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setOpCategoryDescription('');
    setStitchLengthMin('');
    setStitchLengthMax('');
    setPerformancePercentage('');
    setActive('');
    errors.OpCategoryDescription = false;
    errors.StitchLengthMin = false;
    errors.StitchLengthMax = false;
    errors.PerformancePercentage = false;
    errors.Active = false;
    helperTexts.OpCategoryDescription = '';
    helperTexts.StitchLengthMin = '';
    helperTexts.StitchLengthMax = '';
    helperTexts.PerformancePercentage = '';
    helperTexts.Active = '';
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();

    const inputValidation =
      errors.OpCategoryDescription ||
      // errors.StitchLengthMin ||
      // errors.StitchLengthMax ||
      // errors.PerformancePercentage ||
      errors.Active ||
      !OpCategoryDescription ||
      // !StitchLengthMin ||
      // !StitchLengthMax ||
      // !PerformancePercentage ||
      !Active;

    if (inputValidation) {
      if (!OpCategoryDescription) {
        setErrors((prevErrors) => ({ ...prevErrors, OpCategoryDescription: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          OpCategoryDescription: 'Please Enter Category Description',
        }));
      }
      // if (!StitchLengthMin) {
      //   setErrors((prevErrors) => ({ ...prevErrors, StitchLengthMin: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     StitchLengthMin: 'Please Enter Min Stitch Length',
      //   }));
      // }
      // if (!StitchLengthMax) {
      //   setErrors((prevErrors) => ({ ...prevErrors, StitchLengthMax: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     StitchLengthMax: 'Please Enter Max Stitch Length ',
      //   }));
      // }
      // if (!PerformancePercentage) {
      //   setErrors((prevErrors) => ({ ...prevErrors, PerformancePercentage: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     PerformancePercentage: 'Please Enter Performance Percentage',
      //   }));
      // }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'Please select Active Status',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      OpCategoryDescription: false,
      StitchLengthMin: false,
      StitchLengthMax: false,
      PerformancePercentage: false,
      Active: false,
    }));

    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      OpCategoryDescription: '',
      StitchLengthMin: '',
      StitchLengthMax: '',
      PerformancePercentage: '',
      Active: '',
    }));
    const newData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      OpCategoryId: operation === 'Edit' ? editID : '',
      OpCategoryDescription,
      StitchLengthMin: StitchLengthMin === '' ? 0 : StitchLengthMin,
      StitchLengthMax: StitchLengthMax === '' ? 0 : StitchLengthMax,
      PerformancePercentage: PerformancePercentage === '' ? 0 : PerformancePercentage,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    InsertOperationCategoryGrpMstData(newData);

    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'OpCategoryDescription') setOpCategoryDescription(value);
    if (name === 'StitchLengthMin') setStitchLengthMin(value);
    if (name === 'StitchLengthMax') setStitchLengthMax(value);
    if (name === 'PerformancePercentage') setPerformancePercentage(value);
    if (name === 'Active') setActive(value);
    validateInput(name, value);
  };

  // validations
  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const lengthRegex = /^\d{9}$/;
    const isDataExists = opCatData.some(
      (data) => data.OpCategoryDescription.toLowerCase() === value.toLowerCase().trim()
    );
    const isDataExistsinEdit = opCatData.some(
      (data) => data.OpCategoryDescription.toLowerCase() === value.toLowerCase().trim() && data.OpCategoryId !== editID
    );

    if (name === 'OpCategoryDescription') {
      if (!value.trim()) {
        error = true;
        helperText = 'Category Description field cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'Category Description already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEdit) {
        error = true;
        helperText = 'Category Description already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'StitchLengthMin') {
      if (value.length > 0 && !lengthRegex.test(value) && value.length > 9) {
        error = true;
        helperText = 'cannot exceed more than 9 digits';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'StitchLengthMax') {
      if (value.length > 0 && !lengthRegex.test(value) && value.length > 9) {
        error = true;
        helperText = 'cannot exceed more than 9 digits';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'PerformancePercentage') {
      if (value.length > 0 && !lengthRegex.test(value) && value.length > 4) {
        error = true;
        helperText = 'cannot exceed more than 4 digits in %';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'Active') {
      if (!value.trim()) {
        error = true;
        helperText = 'Plaese select user status';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  const handleEdit = (user) => {
    console.log('handleEdit', user);
    setEditID(user.OpCategoryId);
    setOpCategoryDescription(user.OpCategoryDescription);
    setStitchLengthMin(user.StitchLengthMin);
    setStitchLengthMax(user.StitchLengthMax);
    setPerformancePercentage(user.PerformancePercentage);
    setActive(user.Active);
    handleEditOpen();
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (courseId) => {
    setOpenDelete(true);
    setIdToDelete(courseId);
  };

  const handleDeleteConfirmed = (courseId) => {
    DeleteOperationCategoryMst(courseId);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  // search & filter
  const filteredData = opCatData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Operation Category Master
            </Typography>
          </Typography>
        </Grid>
        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<PlaylistAddIcon />}
          >
            Add Category
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Category</StyledTableCell>
                <StyledTableCell align="left">Min length</StyledTableCell>
                <StyledTableCell align="left">Max length</StyledTableCell>
                <StyledTableCell align="center">{`Performance (%)`}</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((data, index) => (
                <TableRow key={index} hover>
                  <TableCell align="center">{data.SNo}</TableCell>
                  <TableCell align="left">{data.OpCategoryDescription}</TableCell>
                  <TableCell align="left">{data.StitchLengthMin}</TableCell>
                  <TableCell align="left">{data.StitchLengthMax}</TableCell>
                  <TableCell align="center">{data.PerformancePercentage}</TableCell>
                  <TableCell align="center">
                    {data.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(data)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(data.data)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={1} fontWeight={600} color="primary">
                  {operation} Operation Category
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={1}>
                <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                  <Grid item md={12}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Operation Category"
                      name="OpCategoryDescription"
                      value={OpCategoryDescription === null ? '' : OpCategoryDescription}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      size="small"
                      error={errors.OpCategoryDescription}
                      helperText={helperTexts.OpCategoryDescription}
                      className={isFormSubmitted && errors.OpCategoryDescription ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      color="primary"
                      label="Minimum Stitch Length "
                      name="StitchLengthMin"
                      value={StitchLengthMin === null ? '' : StitchLengthMin}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.StitchLengthMin}
                      helperText={helperTexts.StitchLengthMin}
                      className={isFormSubmitted && errors.StitchLengthMin ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      color="primary"
                      label="Maximum Stitch Length"
                      name="StitchLengthMax"
                      value={StitchLengthMax === null ? '' : StitchLengthMax}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.StitchLengthMax}
                      helperText={helperTexts.StitchLengthMax}
                      className={isFormSubmitted && errors.StitchLengthMax ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <TextField
                      type="number"
                      variant="outlined"
                      color="primary"
                      label="Performance(%)"
                      name="PerformancePercentage"
                      value={PerformancePercentage === null ? '' : PerformancePercentage}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      error={errors.PerformancePercentage}
                      helperText={helperTexts.PerformancePercentage}
                      className={isFormSubmitted && errors.PerformancePercentage ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item md={12}>
                    {' '}
                    <FormControl size="small" fullWidth component="fieldset">
                      <Stack direction={'row'} justifyContent={'flex-start'} algnItems={'center'} spacing={2}>
                        <FormLabel component="legend" sx={{ pt: 1 }}>
                          Active Status
                        </FormLabel>
                        <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                          <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                          <FormControlLabel value="N" control={<Radio />} label="No" />
                        </RadioGroup>
                      </Stack>
                      {errors.Active && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                        >
                          {errors.Active && helperTexts.Active}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Button type="submit" variant="contained" color="primary" size="small" sx={{ boxShadow: 1 }} fullWidth>
                  Save
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>
      </Grid>

      {/* confirmation dialog */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default OpeationCategory;
